import { useCallback } from "react";

import { type FrontendPortal } from "@vega-api/generated/types/frontendPortal";
import { LocalStorageKeys } from "@vega-core/constants/cookies";
import { isFalsy } from "@vega-core/utils/isFalsy";

import { useAuth } from "./useAuth";

export const useClearCacheIfNewVersion = ({
  source,
}: {
  source: FrontendPortal;
}) => {
  const { logout } = useAuth();

  const clearCacheIfNewVersion = useCallback(
    (appVersion: string) => {
      const storedVersion = localStorage.getItem(LocalStorageKeys.AppVersion);

      if (isFalsy(storedVersion) && appVersion) {
        // Set the appVersion in local storage if it's not already set
        localStorage.setItem(LocalStorageKeys.AppVersion, appVersion);
      } else if (appVersion && storedVersion !== appVersion) {
        // Log out if there is a difference in the build version
        localStorage.clear();
        sessionStorage.clear();

        localStorage.setItem(LocalStorageKeys.AppVersion, appVersion);

        logout({ isGlobal: true, savePath: true, source }); // will clear the token, cookies and redirect to login
      }
    },
    [logout, source],
  );

  return {
    clearCacheIfNewVersion,
  };
};
